module.exports = __webpack_public_path__ + "static/img/s-oppo-4.3be1e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-oppo-4.png
// module id = nXMU
// module chunks = 1